import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './App.css';
import './theme.css';
import { AuthProvider, useAuth } from './context/AuthContext';
import { UserAuthProvider } from './context/UserAuthContext';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import UserLogin from './components/UserLogin';
import UserRegister from './components/UserRegister';
import UserDashboard from './components/UserDashboard';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import PublicUpload from './components/PublicUpload';

const AppContent: React.FC = () => {
  const { isAuthenticated } = useAuth();

  return (
    <div className="App">
      <Routes>
        {/* Public upload page */}
        <Route path="/upload" element={<PublicUpload />} />
        
        {/* User authentication routes - default login */}
        <Route path="/" element={<UserLogin />} />
        <Route path="/user/login" element={<UserLogin />} />
        <Route path="/user/register" element={<UserRegister />} />
        <Route path="/user/dashboard" element={<UserDashboard />} />
        
        {/* Admin authentication routes */}
        <Route path="/admin/login" element={<Login />} />
        
        {/* Admin dashboard routes */}
        <Route path="/admin/*" element={isAuthenticated ? <Dashboard /> : <Login />} />
      </Routes>
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <UserAuthProvider>
          <AppContent />
        </UserAuthProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
